module.exports = __webpack_public_path__ + "media/newstyle/images/icon-check-white-e96a90fe2cc7763aaffc19359fe07c34.svg";